<div class="loading-overlay">
    <div class="loading-spinner"></div>
    <div class="maxim-logo">
        <img src="../../../../assets/image/MAXIM Logo-01.png" alt="">
    </div>
</div>